import { useEffect } from "react";
import "./Work.css";

// const oldProjects = [
//   {
//     id: "01",
//     tag: "Product Design · 2024",
//     title: "Fintech Dashboard Redesign",
//     desc: "End-to-end redesign of a B2B financial platform serving 200k+ users. Stakeholder interviews, journey mapping, component architecture, and full implementation. Reduced task completion time by 38%.",
//     featured: true,
//   },
//   {
//     id: "02",
//     tag: "Design System · 2023",
//     title: "Atomic Design System",
//     desc: "Built a scalable, documented component library in React + Storybook used across 6 product lines. Reduced design debt by 60%.",
//     featured: false,
//   },
//   {
//     id: "03",
//     tag: "Mobile App · 2023",
//     title: "Health & Wellness iOS App",
//     desc: "Onboarding flow redesign driven by usability testing. Lifted D7 retention by 22% and improved App Store rating from 3.8 to 4.7.",
//     featured: false,
//   },
//   {
//     id: "04",
//     tag: "E-Commerce · 2022",
//     title: "Checkout Flow Optimization",
//     desc: "Reduced cart abandonment by 31% through progressive disclosure patterns and inline validation.",
//     featured: false,
//   },
// ];

const projects = [
  {
    id: "01",
    tag: "Case Study · UX Design",
    title: "HerBiz",
    desc: "A platform designed to empower women entrepreneurs with tools and resources to grow their businesses. Full case study covering research, ideation, and UI design.",
    featured: true,
    link: "https://www.figma.com/design/KUo22BRe72JTRYMzKRd8Z6/HerBiz-Case-Study?node-id=2651-4613&t=cCQLajqVSP9APsiV-1",
  },
  {
    id: "02",
    tag: "Case Study · Accessibility",
    title: "Eye Pal",
    desc: "An accessibility-focused app designed to assist visually impaired users in navigating daily tasks with ease and independence.",
    featured: true,
    link: "https://www.figma.com/design/uUKCi4wOWhNzYAp0U5eLqj/Eye-Pal?node-id=405-10418&t=rWlA4VYRdbC33q7s-1",
  },
];

export default function Work() {
  // Scroll reveal on mount
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="work-section">
      <p className="section-label reveal">All Projects</p>

      <div className="work-grid">
        {projects.map((project, i) => (
          <a
            key={project.id}
            href={project.link}
            target="_blank"
            rel="noopener noreferrer"
            className={`work-card reveal ${project.featured ? "featured" : ""}`}
            style={{ transitionDelay: `${i * 0.1}s`, textDecoration: "none" }}
          >
            <div className="work-card-num">{project.id}</div>
            <span className="work-tag">{project.tag}</span>
            <h2 className="work-title">{project.title}</h2>
            <p className="work-desc">{project.desc}</p>
            <div className="work-arrow">↗</div>
          </a>
        ))}
      </div>
    </section>
  );
}